module.exports = __webpack_public_path__ + "static/media/component.18afa3fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/createReactApp/component.png
// module id = 50
// module chunks = 0